function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-220 -175.212)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M297.382,175.589a6.841,6.841,0,1,1-8.693,4.246,6.837,6.837,0,0,1,8.693-4.246Z",
  transform: "translate(-59.705)",
  className: "accent",
  fill: "#f7e842",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(220 177.793)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M240.713,200.941a2.433,2.433,0,0,0-.945.189,3.188,3.188,0,0,0,.013-.353,5.092,5.092,0,0,0-9.386-2.721,5,5,0,0,0-1.89-.365,5.092,5.092,0,0,0-5.09,5.09,3.069,3.069,0,0,0,.013.34,2.433,2.433,0,0,0-.945-.189,2.476,2.476,0,1,0,0,4.952h16.177a1.758,1.758,0,0,0,1.764-1.751,1.707,1.707,0,0,0-.025-.252h.315a2.469,2.469,0,1,0,0-4.939Zm-2.054,6.312h-16.19a1.858,1.858,0,1,1,0-3.717,1.784,1.784,0,0,1,1.134.4.326.326,0,0,0,.353.025.306.306,0,0,0,.139-.328,4.424,4.424,0,0,1-.076-.857,4.465,4.465,0,0,1,7.534-3.251l.013.013a.762.762,0,0,1,.1.1l.1.1a.174.174,0,0,1,.038.05,4.468,4.468,0,0,1,.983,1.751h0a1.475,1.475,0,0,1,.063.252.044.044,0,0,0,.013.025c0,.013.013.025.013.038s.013.025.025.038.013.025.025.025l.038.038.013.013a.1.1,0,0,0,.05.025h.013a.337.337,0,0,0,.29-.025,2.872,2.872,0,0,1,4.46,2.406,1.606,1.606,0,0,1-.025.353v.088a.358.358,0,0,0,.05.151c.013.025.038.038.05.063a.314.314,0,0,0,.315.05,1.354,1.354,0,0,1,.466-.1.613.613,0,0,1,.151.013.076.076,0,0,1,.05.013.234.234,0,0,1,.088.025.711.711,0,0,1,.151.05h0a1.173,1.173,0,0,1,.554.491c.025.038.038.076.063.113v.013a1.25,1.25,0,0,1,.088.441A1.116,1.116,0,0,1,238.659,207.253Zm2.054-1.991H240.2a1.732,1.732,0,0,0-1.348-.895h-.025c-.05,0-.113-.013-.164-.013a1.893,1.893,0,0,0-.252.025,3.5,3.5,0,0,0-3.49-3.5h-.252c-.05,0-.1.013-.151.013h-.025a3.5,3.5,0,0,0-1.121.34,5.255,5.255,0,0,0-.907-1.676l-.025-.025a1.1,1.1,0,0,1-.1-.126c-.025-.025-.038-.05-.063-.076l-.013-.013a5.108,5.108,0,0,0-1.3-1.021,4.519,4.519,0,0,1,3.729-2,4.471,4.471,0,0,1,4.473,4.46,4.332,4.332,0,0,1-.076.857.314.314,0,0,0,.139.328.325.325,0,0,0,.353-.013,1.909,1.909,0,0,1,1.147-.391,1.858,1.858,0,0,1,1.865,1.852A1.882,1.882,0,0,1,240.713,205.263Z",
  transform: "translate(-220 -195.7)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.98,299.1a.294.294,0,0,0-.416.113l-1.965,3.364a.294.294,0,0,0,.113.416.336.336,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.953-3.364A.306.306,0,0,0,233.98,299.1Z",
  transform: "translate(-230.1 -286.034)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M271.455,299.1a.294.294,0,0,0-.416.113l-1.94,3.364a.294.294,0,0,0,.113.416.336.336,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.94-3.364A.3.3,0,0,0,271.455,299.1Z",
  transform: "translate(-262.875 -286.034)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.855,299.1a.294.294,0,0,0-.416.113l-1.94,3.364a.294.294,0,0,0,.113.416.336.336,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.94-3.364A.3.3,0,0,0,308.855,299.1Z",
  transform: "translate(-295.563 -286.034)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M346.255,299.1a.294.294,0,0,0-.416.113l-1.94,3.364a.294.294,0,0,0,.113.416.336.336,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.94-3.364A.3.3,0,0,0,346.255,299.1Z",
  transform: "translate(-328.251 -286.034)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M239.868,334.2a.294.294,0,0,0-.416.113l-1.953,3.364a.294.294,0,0,0,.113.416.335.335,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.953-3.364A.294.294,0,0,0,239.868,334.2Z",
  transform: "translate(-235.256 -316.711)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.268,334.2a.294.294,0,0,0-.416.113l-1.953,3.364a.294.294,0,0,0,.113.416.335.335,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.953-3.364A.294.294,0,0,0,277.268,334.2Z",
  transform: "translate(-267.944 -316.711)",
  className: "primary",
  fill: "#4e4e4e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.755,334.2a.294.294,0,0,0-.416.113l-1.94,3.364a.294.294,0,0,0,.113.416.335.335,0,0,0,.151.038.3.3,0,0,0,.265-.151l1.94-3.364A.294.294,0,0,0,314.755,334.2Z",
  transform: "translate(-300.719 -316.711)",
  className: "primary",
  fill: "#4e4e4e"
})));

var SvgRain = function SvgRain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.195,
    height: 24,
    viewBox: "0 0 23.195 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rain.b4cdacac.svg";
export { ForwardRef as ReactComponent };